export const finixKeys = {
  all: ['finix'] as const,
  webhookEvents: (
    whereClauses: Array<[string, string, unknown]> = [],
    orderByField?: string,
    orderDirection?: string,
  ) =>
    [
      ...finixKeys.all,
      'webhookEvents',
      JSON.stringify(whereClauses),
      orderByField,
      orderDirection,
    ] as const,
};
